<div class="detail-authority-card-mobile">
  <div class="display-block">
    <span>Line: {{ lineItem.lineNumber }}</span>
    <span class="operate-on">Operate On: {{ lineItem?.operateOn }}</span>
  </div>
  <div class="display-block">
    <span>From: </span>
    <span class="green"> {{ lineItem.fromPoint.displayName }}, </span><span>{{ lineItem.fromPoint.location.track.name }}</span>
  </div>
  <div class="display-block">
    <span>To: </span>
    <span class="green"> {{ lineItem.toPoint.displayName }}, </span><span>{{ lineItem.toPoint.location.track.name }}</span>
  </div>
  <div class="display-block">
    <span>Direction: </span>
    <span> {{ Direction[lineItem.direction] }}</span>
  </div>
</div>
